// Styles
import styles from './MainLayout.module.sass'

// Components
import Header from '@components/v25/es/common/header/Header'

const MainLayout = ({
  children,
  backgroundColor,
  displayCounter = false,
  displayHeader = true,
  discount,
  signUpLink,
  sectionLink
}: {
  children: React.ReactNode
  backgroundColor?: string
  displayCounter?: boolean
  displayHeader?: boolean
  discount?: number
  signUpLink?: string
  sectionLink?: string
}) => {
  return (
    <div
      className={`getaway-scan-v25 ${styles.container}`}
      style={{ backgroundColor: backgroundColor || '#E5E5E5' }}
    >
      {displayHeader && (
        <Header
          displayCounter={displayCounter}
          discount={discount}
          signUpLink={signUpLink}
          sectionLink={sectionLink}
        />
      )}

      <main
        className={`${styles.main} ${styles[displayCounter ? 'md' : 'sm']} ${
          !displayHeader ? styles.hideHeader : ''
        }`}
      >
        {children}
      </main>
    </div>
  )
}

export default MainLayout
